module.exports = __webpack_public_path__ + "files/71926af81e369b1c349667824db09358.png";